
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kontakt",
      function () {
        return require("private-next-pages/kontakt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kontakt"])
      });
    }
  